import React, { useCallback, useState } from 'react'
import { ZdsIcon } from '@zera/components'
import { ApproveButton, DisapproveButton } from './styles'
import { Message } from '../Message'
import { Center, Stack } from '~/styles'
import { usePostLLMFeedback } from '~/hooks/llm/usePostLLMFeedback'
import { IconComponent } from '~/assets/icons/component'

type RatingResultsMessageProps = {
  messageId: string
}

export const RatingResultsMessage = ({ messageId }: RatingResultsMessageProps): JSX.Element => {
  const [userFeedback, setSelectedOption] = useState<'approve' | 'disapprove' | null>(null)
  const { mutate, isError, isLoading } = usePostLLMFeedback({
    onError: () => {
      setSelectedOption(null)
    }
  })

  const approveMessage = useCallback(() => {
    setSelectedOption('approve')
    mutate({ body: { id: messageId, feedback: true } })
  }, [messageId, mutate])

  const disapproveMessage = useCallback(() => {
    setSelectedOption('disapprove')
    mutate({ body: { id: messageId, feedback: false } })
  }, [messageId, mutate])

  return (
    <Message.RootLeft>
      <Message.UserAvatar iconName="MiMaleDoctor" />
      <Stack spacing="0.5rem" alignItems="flex-start">
        <Message.UserName username="IA Interativa" />
        <Message.FromLeft>
          <Stack alignItems="flex-start">
            <Message.PlainText text="As informações fornecidas estão corretas e completas?" />
            <Stack width="100%" alignItems="flex-start">
              <ApproveButton
                className={userFeedback === 'approve' ? 'selected' : ''}
                disabled={!!userFeedback}
                onClick={approveMessage}
              >
                <Center gap="0.5rem">
                  {isLoading ? <IconComponent name="load" iconsize={25} /> : <ZdsIcon src="MiThumbUp" />}
                  Sim
                </Center>
              </ApproveButton>
              <DisapproveButton
                className={userFeedback === 'disapprove' ? 'selected' : ''}
                disabled={!!userFeedback}
                onClick={disapproveMessage}
              >
                <Center gap="0.5rem">
                  {isLoading ? <IconComponent name="load" iconsize={25} /> : <ZdsIcon src="MiThumbUp" />}
                  Não
                </Center>
              </DisapproveButton>
            </Stack>
          </Stack>
        </Message.FromLeft>
        <Message.ErrorIndicator show={isError} />
      </Stack>
    </Message.RootLeft>
  )
}
